import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Company } from '../pages/company/company.page';
import { Documents } from 'pages/documents/documents.page';
import { Shareholders } from 'pages/shareholders/shareholders.page';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="compliance">
          <Route path="company" element={<Company />} />
          <Route path="documents" element={<Documents />} />
          <Route path="shareholders" element={<Shareholders />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
